import React, { useState, useEffect, Fragment, useRef } from 'react'
import '../../../../assets/css/pantalla1.css'
import '../../../../assets/css/cartaConsentimiento.css'
import { Container, Row, Col, Label, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useConsentimiento } from '../../../../hooks/tomaMuestra/useConsentimiento';
import { useLogin } from '../../../../hooks/tomaMuestra/useLogin';
import 'animate.css';
import { sendRequest } from '../../../../hooks/requests/useRequest';
import { ComponentInformedSurvey } from './ComponentInformedSurvey';
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';
import { Messages } from 'primereact/messages';
import { useSweetAlert } from "../../../../hooks/sweetAlerts/useSweetAlert";





export const InformedConsent = () => {

    const { nimm } = useParams();
    let name2 = localStorage.getItem('flebotomisaNombre');


    const [show, setShow] = useState(true);
    const [show1, setShow1] = useState(true);
    const [nim, setNim] = useState("");
    const [patient, setPatient] = useState("");
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()


    const {
        navigaConsentimientoInformado1, navigateSampling,

        hour, minute, second, iniImg,
        difHourBrakfast, difMinuteBrakfast, repeatFirm,

        InformedConsent, handleSelectOption, handleInputChange, handleBack,
        handleAyuno, selectedHour, setSelectedHour, calculateAyuno,
        setInformedConsent, handleChange, handleFinish,

        modalRefused, toggleRefused, handleCancell, listRefused, id_cancellation_reazon_sample,
        handleSelectValuesR, msgs, refusedPatient,

    } = useConsentimiento();


    // ==========================================
    // INICIO DE NUEVO CÓDIGO: BLOQUEO DE GESTO "ATRÁS"
    // ==========================================
    useEffect(() => {
        // 1. Forzamos una entrada nueva en el historial al montar el componente
        window.history.pushState(null, null, window.location.href);

        const handlePopState = (event) => {
            // 2. El usuario hizo el gesto de regresar (swipe o botón atrás) en la tablet
            // Volvemos a empujar el estado para mantenerlo "atrapado" en esta vista
            window.history.pushState(null, null, window.location.href);

            // 3. Mostramos la alerta de SweetAlert para explicarle por qué no pasó nada
            createSweet(
                "warning",
                "Acción no permitida",
                "Navegación bloqueada",
                "Para evitar perder la información de la toma de muestra, por favor utiliza los botones de la pantalla."
            );
        };

        // Escuchamos el evento de navegación del historial
        window.addEventListener('popstate', handlePopState);

        // Evitar que el usuario recargue la página por accidente (F5 o swipe hacia abajo)
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = ''; // Necesario para la mayoría de navegadores modernos
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        // 4. Limpieza: Se ejecuta cuando el componente muere (para no afectar otras pantallas)
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []); // El array vacío equivale a ponerlo en el constructor o Page_Load de C#
    // ==========================================
    // FIN DE NUEVO CÓDIGO
    // ==========================================



    const { time, reload } = useLogin();

    const canvasRef = useRef(null);

    useEffect(() => {

        if (nimm !== undefined) {
            getDataFromNimPost(nimm)
        }
    }, [nimm]);

    const getDataFromNimPost = async (nimm) => {

        let body = {
            nim: nimm.substring(0, 13),
            id_departament: localStorage.getItem('depW')
        }

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "Sass/GetDataFromPatient");

        if (respuesta.code === 200) {
            let namePatient = "";
            let nimPatient = "";


            respuesta.data.lista_pruebas.forEach(element => {

                namePatient = element.name_patient
                nimPatient = element.nim
            });
            setNim(nimPatient);
            setPatient(namePatient);
        }
    }




    return (
        <Fragment>
            <Container fluid={true} className='bg-barra1'>
                <Col sm="12">
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-0"> <br />
                            <div className='box-departamento'>
                                <Col sm="12" style={{ textAlign: "-webkit-center" }}>
                                    <Row>
                                        <Col xs="2" sm="2" md="2" lg="2" xl="2">
                                            <Label className='labelToma1'>{time}</Label>
                                        </Col>
                                        <Col xs="7" sm="7" md="7" lg="7" xl="7"  >
                                            <label className='labelToma1'>Toma de Muestra</label>
                                        </Col>

                                        <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-1' style={{ textAlign: "-webkit-right" }}>
                                            {
                                                show1 ? (<label className='rc'>{hour}:{minute}:{second}</label>) : ""
                                            }
                                        </Col>
                                        <Col xs="1" sm="1" md="1" lg="1" xl="1" className='p-2' >
                                            {
                                                show1 ? (<img className=" " src={require("../../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "27%" }} alt="" />
                                                ) : ""
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>

                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row>

                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <Col style={{ position: 'fixed', right: 0, bottom: 0, zIndex: 5, width: '250px', height: '380px', borderTopLeftRadius: '12px', padding: '10px' }} className='divMenu p-l-0'>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12"><br /> <br />
                                            {
                                                show ?
                                                    (
                                                        <div></div>
                                                    )
                                                    :
                                                    (
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                            <div className='username-Active ' >
                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                    <Row>
                                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-0' style={{ textAlign: "-webkit-center" }} >
                                                                            <br />
                                                                            <i className="fa fa-circle icon-active-small"></i>
                                                                        </Col>
                                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0'> <br />
                                                                            <label className='label-menuToma p-0'>{name2}</label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </div> <br />

                                                            <div className="username-Active pointer " onClick={reload} >
                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                    <Row>
                                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2' style={{ textAlign: "-webkit-center" }}> <br />
                                                                            <img
                                                                                className=" "
                                                                                src={require("../../../../assetsToma/imagenes/Recargar.png")}
                                                                                style={{ width: "40%" }}
                                                                                alt=""
                                                                            />
                                                                        </Col>
                                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                                                                            <label className="r-label-active p-0 pointer">
                                                                                {"Recargar"}
                                                                            </label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </div>{" "} <br />
                                                            <div className='username-Active pointer' onClick={() => { setShow1(!show1); }}>
                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                    <Row>
                                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                                                                            <img className=" " src={require("../../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "45%" }} alt="" />
                                                                        </Col>
                                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                                                                            <label className='r-label-active p-0 pointer'>{"Cronómetro"}</label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </div><br />
                                                            <div className='username-Active pointer' onClick={() => handleCancell()}   >
                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                    <Row>
                                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }} > <br />
                                                                            <img className=" " src={require("../../../../assetsToma/imagenes/CerrarBlanco.png")} style={{ width: "36%" }} alt="" />
                                                                        </Col>
                                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 ' > <br />
                                                                            <label className='r-label-active p-0 pointer'>{"Cancelar Toma"}</label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </div>
                                                        </Col>
                                                    )
                                            }
                                        </Col>
                                    </Col>

                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Col sm="12" className='p-l-0 p-r-0' >
                        {
                            InformedConsent.length > 0 &&
                            <ComponentInformedSurvey
                                items={InformedConsent}
                                onSelectOption={handleSelectOption}
                                onInputChange={handleInputChange}
                                onBack={handleBack}
                                handleAyuno={handleAyuno}
                                selectedHour={selectedHour}
                                setSelectedHour={setSelectedHour}
                                difHourBrakfast={difHourBrakfast}
                                difMinuteBrakfast={difMinuteBrakfast}
                                calculateAyuno={calculateAyuno}
                                setInformedConsent={setInformedConsent}
                                canvasRef={canvasRef}
                                handleChange={handleChange}
                                iniImg={iniImg}
                                handleFinish={handleFinish}
                                repeatFirm={repeatFirm}
                            />
                        }
                        {
                            InformedConsent.length === 0 && <div>
                                <label htmlFor="">Cargando</label>
                            </div>
                        }

                    </Col>
                    <div className='tap-top' style={{ display: "block" }} onClick={() => { setShow(!show); }}><i className="icon-angle-double-up f-24"></i>
                    </div>
                </Col>
            </Container >
            <Dialog
                header="Rechazar toma de muestra "
                visible={modalRefused}
                headerStyle={{
                    backgroundColor: "#bd2130",
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: "#bd2130", color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                onHide={toggleRefused}
                className="large-dialog-sample"
                footer={
                    <>
                        {
                            <Button
                                size="sm"
                                color="danger"
                                type="button"
                                onClick={() => refusedPatient()}
                            >
                                {"Aceptar"}
                            </Button>
                        }
                        <Button
                            size="sm"
                            type="button"
                            color="secondary"
                            className="btn-air-light"
                            onClick={toggleRefused}
                        >
                            {"Cancelar" ?? "---"}
                        </Button>
                    </>
                }
            >
                <Col sm="12" className="pt-2 p-l-0 p-r-0 ">
                    <Messages ref={msgs} />


                    <div
                        style={{
                            backgroundColor: "#fff8e1",
                            border: "1px solid #ffe9a8",
                            padding: "10px 14px",
                            borderRadius: "8px",
                            color: "#8a6d3b",
                            fontSize: "0.85rem",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                        }}
                    >
                        <i
                            className="fa fa-exclamation-circle"
                            style={{ color: "#d39e00", fontSize: "18px" }}
                        />
                        Selecciona el motivo para rechazar esta toma de muestra
                    </div>

                    <div style={{ marginTop: "12px" }}>
                        <Select
                            classNamePrefix="select"
                            name="id_cancellation_reazon_sample"
                            value={id_cancellation_reazon_sample}
                            options={listRefused}
                            onChange={(e) =>
                                handleSelectValuesR(e, "id_cancellation_reazon_sample")
                            }
                            isClearable={true}
                            placeholder="Selecciona un motivo..."
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({
                                    ...base,
                                    borderRadius: "8px",
                                    borderColor: "#cbd5e1",
                                    padding: "2px",
                                    minHeight: "42px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "#94a3b8",
                                    },
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    padding: "10px 14px",
                                    fontSize: "0.9rem",
                                    backgroundColor: state.isSelected
                                        ? "#3b82f6"
                                        : state.isFocused
                                            ? "#e2e8f0"
                                            : "white",
                                    color: state.isSelected ? "white" : "#334155",
                                    cursor: "pointer",
                                }),
                            }}
                        />
                    </div>
                    <Col sm="12" className="mt-4 p-l-0 p-r-0"  >
                        <div
                            style={{
                                backgroundColor: 'white', border: '1px solid #e0e0e0',
                                borderRadius: '10px', padding: '12px', fontSize: '12px'
                            }}
                            className="shadow-sm"
                        >
                            <div>
                                <span style={{ fontWeight: "600", color: "#475569" }}>Paciente:</span>{" "}
                                <span style={{ color: "#334155" }}>{patient}</span>
                            </div>

                            <div className="mt-1">
                                <span style={{ fontWeight: "600", color: "#475569" }}>NIM:</span>{" "}
                                <span style={{ color: "#334155" }}>{nim}</span>
                            </div>

                            <div>
                                <span style={{ fontWeight: "600", color: "#475569" }}>Motivo de rechazo:</span>{" "}
                                <span className='f-w-600' style={{ color: "#334155" }}>{id_cancellation_reazon_sample !== null ? id_cancellation_reazon_sample.label ?? "----" : null}</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Dialog >
        </Fragment >
    )
}
